import { useState } from "react";
import Header from "@/components/Header";
import Footer from "@/components/Footer";
import HeroSection from "@/components/HeroSection";
import CategoriesSection from "@/components/CategoriesSection";
import FeaturesSection from "@/components/FeaturesSection";
import AnnouncementsSection from "@/components/AnnouncementsSection";
import RamadanWelcome from "@/components/RamadanWelcome";
import { useNavigate } from "react-router-dom";

const Index = () => {
  const navigate = useNavigate();
  const [showRamadan, setShowRamadan] = useState(true);

  if (showRamadan) {
    return (
      <RamadanWelcome onContinue={() => setShowRamadan(false)} />
    );
  }

  return (
    <div className="min-h-screen bg-background flex flex-col">
      <Header showSearch={false} />
      <main className="flex-grow">
        <HeroSection onScrollToResources={() => navigate('/templates')} />
        <AnnouncementsSection />
        <CategoriesSection />
        <FeaturesSection />
      </main>
      <Footer />
    </div>
  );
};

export default Index;
